<ng-template #titleTpl>
  @if (solicitud(); as sol) {
    <intelishs-page-header [title]="sol.empleadoNombre" [subtitle]="subtitulo()" />
  }
</ng-template>

<nz-modal
  [nzVisible]="visible()"
  [nzTitle]="titleTpl"
  [nzFooter]="modalFooter"
  nzWidth="620px"
  (nzOnCancel)="cerrar()"
>
  <ng-template nzModalContent>
    @if (solicitud(); as sol) {
      <div class="edit-admin-modal">
        <!-- ── Sección: estatus + comentario del empleado ── -->
        <!-- Dropdown de estatus: override administrativo libre. Cambiar este -->
        <!-- valor NO dispara stamp en Director ni RH (mutua exclusión con   -->
        <!-- las otras dos). -->
        <div class="edit-seccion">
          <intelishs-section-header title="Solicitud del empleado" />
          <div class="edit-row">
            <div class="edit-field edit-field--full sinay-select-floating">
              <nz-select
                nzId="estEmpleado"
                [ngModel]="editEmpleadoEstatus()"
                (ngModelChange)="onEmpleadoEstatusChange($event)"
              >
                @for (op of empleadoEstatusOpciones; track op.value) {
                  <nz-option [nzValue]="op.value" [nzLabel]="op.label" />
                }
              </nz-select>
              <label class="sinay-float-label" for="estEmpleado">Estatus</label>
            </div>
          </div>
          <div class="edit-row">
            <div class="edit-field edit-field--full sinay-input-floating">
              <textarea
                id="comEmpleado"
                nz-input
                class="sinay-input sinay-input--floating"
                rows="3"
                placeholder=" "
                [ngModel]="editComentarios()"
                (ngModelChange)="editComentarios.set($event)"
              ></textarea>
              <label class="sinay-float-label" for="comEmpleado"> Comentarios del empleado </label>
            </div>
          </div>
        </div>

        <!-- ── Sección: Director ── -->
        <!-- Si esta sección se edita (estatus, comentario o nota), al guardar -->
        <!-- se setea SuperiorAutorizaId = editor y FechaAutorizacionSuperior = ahora. -->
        <div class="edit-seccion">
          <intelishs-section-header title="Resolución del Director" />
          <div class="edit-row">
            <div class="edit-field edit-field--full sinay-select-floating">
              <nz-select
                nzId="estDirector"
                [ngModel]="editDirectorEstatus()"
                (ngModelChange)="onDirectorEstatusChange($event)"
              >
                @for (op of directorEstatusOpciones; track op.value) {
                  <nz-option [nzValue]="op.value" [nzLabel]="op.label" />
                }
              </nz-select>
              <label class="sinay-float-label" for="estDirector">Estatus (Director)</label>
            </div>
          </div>
          <div class="edit-row">
            <div class="edit-field edit-field--full sinay-input-floating">
              <textarea
                id="comDirector"
                nz-input
                class="sinay-input sinay-input--floating"
                rows="3"
                placeholder=" "
                [ngModel]="editComentariosDirector()"
                (ngModelChange)="editComentariosDirector.set($event)"
              ></textarea>
              <label class="sinay-float-label" for="comDirector">
                Comentario visible para el empleado
              </label>
            </div>
          </div>
        </div>

        <!-- ── Sección: RH ── -->
        <!-- Misma lógica de autostamp: si se edita esta sección, RhAutorizaId -->
        <!-- = editor y FechaAutorizacionRh = ahora. -->
        <div class="edit-seccion">
          <intelishs-section-header title="Resolución de RH" />
          <div class="edit-row">
            <div class="edit-field edit-field--full sinay-select-floating">
              <nz-select
                nzId="estRh"
                [ngModel]="editRhEstatus()"
                (ngModelChange)="onRhEstatusChange($event)"
              >
                @for (op of rhEstatusOpciones; track op.value) {
                  <nz-option [nzValue]="op.value" [nzLabel]="op.label" />
                }
              </nz-select>
              <label class="sinay-float-label" for="estRh">Estatus (RH)</label>
            </div>
          </div>
          <div class="edit-row">
            <div class="edit-field edit-field--full sinay-input-floating">
              <textarea
                id="comRh"
                nz-input
                class="sinay-input sinay-input--floating"
                rows="3"
                placeholder=" "
                [ngModel]="editComentariosRH()"
                (ngModelChange)="editComentariosRH.set($event)"
              ></textarea>
              <label class="sinay-float-label" for="comRh">
                Comentario visible para el empleado
              </label>
            </div>
          </div>
        </div>
      </div>
    }
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="sinay-outline-reset" (click)="cerrar()">Cancelar</button>
    <button nz-button class="btn-add" [nzLoading]="editGuardando()" (click)="guardar()">
      Guardar cambios
    </button>
  </ng-template>
</nz-modal>
